(() => {
    HuiEmptyResultController.$inject = ['$scope'];

    function HuiEmptyResultController($scope) {
        const self = this;
    }

    angular
        .module("harriApp")
        .directive("huiEmptyResult", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                bindToController: {},
                controllerAs: '$ctrl',
                controller: HuiEmptyResultController,
                templateUrl: `../hmodules/harri-main/ui-components/hui-empty-result.html`
            }
        });

})();